import { ActionIcon } from '@cowbell/ui/core';
import { useShellDrawer, useShellSelection } from '../../provider';
import { CloseIcon, PencilSquareIcon } from './icons';
import styles from './ShellDrawer.module.css';

/** Header of the shell drawer. Title + new-chat icon (resets to a fresh
 *  conversation and closes the drawer) + close X. */
export function DrawerHeader() {
  const drawer = useShellDrawer();
  const { newConversation } = useShellSelection();

  const handleNewChat = () => {
    newConversation();
    drawer.close();
  };

  return (
    <div className={styles.drawerHeader}>
      <span className={styles.drawerTitle}>Ask Moo</span>
      <div>
        <ActionIcon
          className={styles.headerAction}
          variant="subtle"
          color="gray"
          aria-label="New chat"
          onClick={handleNewChat}
        >
          <PencilSquareIcon />
        </ActionIcon>
        <ActionIcon
          className={styles.headerAction}
          variant="subtle"
          color="gray"
          aria-label="Close"
          onClick={drawer.close}
        >
          <CloseIcon />
        </ActionIcon>
      </div>
    </div>
  );
}
